<template>
  <div class="wrapper-bar-3">
    <router-link
      :to="
        $i18nRoute({
          name: 'NewsDetail',
          params: { slug: item.url }
        })
      "
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :class="`card-${index + 1}`"
    >
      <div class="card__img">
        <div class="card__category-img">
          {{ item.sub_category.name }}
        </div>
        <ImageContainer
          class="img"
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
        />
      </div>
      <div class="card__descr">
        <div class="card__category">
          {{ item.sub_category.name }}
        </div>
        <div class="card__title limited-text">{{ item.title }}</div>
        <div class="data-news">
          <span class="day">{{ handleDate(item.pub_date) }},</span>
          <span class="time">{{ handleTime(item.pub_date) }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper-bar-3 {
  padding: 6rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background: url("../../../assets/lifestyle-page/space.jpg") no-repeat;
  background-position: top center;
}
.card {
  display: flex;
  align-items: center;
  gap: 1rem;
  &__img {
    position: relative;
    flex: 0 0 60%;
    width: 100%;
    height: 100%;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      background: linear-gradient(
        130.07deg,
        rgba(107, 142, 245, 0.5) 12.75%,
        rgba(255, 141, 241, 0.5) 101.69%
      );
      filter: blur(120px);
    }
    .img {
      padding-bottom: 70%;
    }
  }
  &__category-img {
    display: none;
  }
  &__descr {
  }
  &__title {
    font-size: 20px !important;
    line-height: 27px !important;
  }
  .data-news {
    font-size: 20px !important;
    line-height: 27px !important;

    color: rgba(255, 255, 255, 0.8);
  }
}
@media screen and (max-width: 767px) {
  .card {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    &__img {
      flex: 0 0 40%;
      .img {
        padding-bottom: 70%;
      }
    }
    &__category-img {
      display: block;
    }
    &__category {
      display: none;
    }
    &__title {
      margin-top: 12px;
      font-size: 16px !important;
      line-height: 20px !important;
      text-align: justify;
    }
    &__category {
      font-size: 14px;
    }
    .data-news {
      font-size: 12px !important;
      line-height: 16px !important;

      color: rgba(255, 255, 255, 0.8);
    }
  }
}
</style>
